import { Typography } from '@mui/material'
import cx from 'classnames'
import React, { type ReactElement } from 'react'

import { type QuestionAnswer, type Question } from '../questionnaires.types'

import styles from './AiQuestion.module.scss'

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')

interface QuestionProps {
  question: Question
  currentAnswerIds: string[]
  handleSelectAnswer: (answer: QuestionAnswer) => void
  multiple?: boolean
}

const AiQuestion: React.FC<QuestionProps> = ({
  question,
  currentAnswerIds,
  handleSelectAnswer,
  multiple,
}): ReactElement => {
  return (
    <>
      <Typography variant={question.description ? 'title2' : 'title3'}>{question.question}</Typography>
      <Typography>{question.description}</Typography>
      {multiple && <Typography>(možete izabrati više odgovora)</Typography>}
      <div className={styles.answers}>
        {question.answers.map((a, i) => (
          <div
            key={a.id}
            className={styles.answer}
            onClick={() => {
              handleSelectAnswer(a)
            }}
          >
            <div
              className={cx(styles.letter, {
                [styles.chosen]: currentAnswerIds.find((id) => id === a.id),
              })}
            >
              {alphabet[i % alphabet.length].toUpperCase()}
            </div>
            <Typography>{a.answer}</Typography>
          </div>
        ))}
      </div>
    </>
  )
}

export default AiQuestion
